import { Checkbox, Stack } from '@chakra-ui/react';

import { FC } from 'react';
import { FieldError, FieldErrorsImpl, FieldValues, Merge, UseFormRegister } from 'react-hook-form';

interface Props {
    id: string;
    name: string;
    selected: boolean;
    register: UseFormRegister<FieldValues>;
    onChange: () => void;
    direction?: 'row' | 'column';
    isRequired?: boolean;
    isInvalid?: FieldError | Merge<FieldError, FieldErrorsImpl<any>> | null;
    disabled?: boolean;
    flex?: number | string;
}

const CheckboxComponent: FC<Props> = ({ id, name = '', selected, onChange, register, flex = 1 }) => {
    return (
        <Stack w="100%" flex={flex} color="gray.600">
            <Checkbox
                size="md"
                isChecked={selected}
                colorScheme="green"
                borderColor="gray.600"
                {...register(id)}
                onChange={onChange}
            >
                {name}
            </Checkbox>
        </Stack>
    );
};

export default CheckboxComponent;
